import RuntimeUtils from 'src/common/js/runtimeUtils';
import { $get, $post, $put, post } from 'src/utils/httpUtil';

const BASE_URL = RuntimeUtils.instance.getConsoleServiceHostname();
const CLOUD_SERVICE_BASE_URL = RuntimeUtils.instance.getObvServiceHostname();
const CONSOLE_SERVE = '/bimserver/console/v3';
const DEVOPSTICKET_SERVE = '/bimserver/devopsticket/v3';
// 发送短信验证码
export const sendCaptchaRequest = (phoneNumber) =>
    new Promise((resolve, reject) => {
        const url = `${RuntimeUtils.instance.getObvServiceProtocol()}//${BASE_URL}${CONSOLE_SERVE}/account/sms/code`;
        $post(url, { mobile: phoneNumber })
            .then((res) => {
                resolve(res);
            })
            .catch((err) => reject(err));
    });

// 绑定用户手机号
export const bindPhoneRequest = (phoneNumber, code) =>
    new Promise((resolve, reject) => {
        const url = `${RuntimeUtils.instance.getObvServiceProtocol()}//${BASE_URL}${CONSOLE_SERVE}/account/bindMobile`;
        $put(url, {
            mobile: phoneNumber,
            code: code,
        })
            .then((res) => {
                resolve(res);
            })
            .catch(reject);
    });

// 发送账户升级邮件
export const sendEmailToAccountUpgrade = (content) =>
    new Promise((resolve, reject) => {
        const url = `${RuntimeUtils.instance.getObvServiceProtocol()}//${BASE_URL}${CONSOLE_SERVE}/account/mail/upgrade`;
        $post(url, {
          userContent: content
        })
            .then((res) => {
                resolve(res);
            })
            .catch(reject);
    });

// 发送resbot工单
export const sendDevopsTicket = (ticketAgrs, token) =>
    new Promise((resolve, reject) => {
        const url = `${RuntimeUtils.instance.getObvServiceProtocol()}//${CLOUD_SERVICE_BASE_URL}${DEVOPSTICKET_SERVE}/tickets`;
        const ticketName = 'cloud官网邮件-' + ticketAgrs.environment + '-' + ticketAgrs.content;
        const data = {
            ticketName: ticketName,
            state: '2',
            type: '3',
            describes: ticketAgrs.describes,
            settings: '',
            expectation: ticketAgrs.expectation,
            priority: '3',
        };
        $post(url, data, token)
            .then((res) => {
                resolve(res);
            })
            .catch(reject);
    });



// WEBPACK FOOTER //
// ./src/utils/sendMessage.js